import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { CompanyWebsiteVariousPageSection } from "@/types/companyWebsiteVariousPage";

export const CHECK_TABLE_KEY_BY_GROUP_TABLE_KEY: {
  "Company Website Various Pages": {
    [key in CompanyWebsiteVariousPageSection]: string | null;
  };
} = {
  [ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages]: {
    "Drug Profile": "Drug",
  },
};
